import { BlockSaveProps } from "@wordpress/blocks";
import React from "react";
import { type BlockAttributes } from "./block.json";
import { useBlockProps, InnerBlocks } from "@wordpress/block-editor";

export default function HeaderSave({
  attributes,
}: BlockSaveProps<BlockAttributes>) {
  return (
    <div
      {...useBlockProps.save()}
      className="header w-100 bg-dark d-flex flex-column flex-xl-row"
    >
      <div className="w-100 position-relative">
        <InnerBlocks.Content />
        <div className="container d-flex justify-content-center position-absolute content-container">
          <div className="content py-5">
            <img src={attributes.imageUrl} alt={attributes.imageAlt} />
          </div>
        </div>
      </div>
    </div>
  );
}
